import type { UUID } from '@/types/common'
import type { ModifyTimeReportRequest, TimeActivitiesResponse, TimeReport, TimeReportsResponse } from '@/types/timeReport'

import { api } from './client'

export interface GetTimeReportsParams {
  year?: number;
  month?: number;
  driverID?: UUID;
  page?: number;
  limit?: number;
  sort?: string[];
}

export interface GetTimeActivitiesParams {
  name?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export const reportsTimeApi = {
  getTimeReports: (params?: GetTimeReportsParams) =>
    api.get<TimeReportsResponse>('/reports/time', params),

  getTimeActivities: (params?: GetTimeActivitiesParams) =>
    api.get<TimeActivitiesResponse>('/reports/time/activities', params),

  createTimeReport: (data: ModifyTimeReportRequest) =>
    api.post<TimeReport>('/reports/time', data),

  getTimeReport: (id: UUID) =>
    api.get<TimeReport>(`/reports/time/${id}`),

  updateTimeReport: (id: UUID, data: ModifyTimeReportRequest) =>
    api.put<TimeReport>(`/reports/time/${id}`, data),

  deleteTimeReport: (id: UUID) =>
    api.delete<void>(`/reports/time/${id}`),

  generateTimeReport: (year: number, month: number) =>
    api.post<Blob>('/reports/time/generate', undefined, { params: { year, month }, responseType: 'blob' }),
}
